"use strict";
exports.__esModule = true;
exports.WebsdkAllavailabilitiesService = void 0;
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var websdk_allavailabilities_helper_service_1 = require("./websdk-allavailabilities-helper.service");
var utils_1 = require("../../core/websdk/utils");
var getAllAvailabilities = function (params) {
    return rxjs_1.from(websdk_allavailabilities_helper_service_1.WebsdkAllavailabilitiesHelperService.fetchAllAvailabilities(params)).pipe(operators_1.map(function (res) { return res.data; }), operators_1.catchError(function (err) {
        utils_1.dispatchErrorEvent(err);
        return rxjs_1.of(null);
    }));
};
exports.WebsdkAllavailabilitiesService = { getAllAvailabilities: getAllAvailabilities };
//# sourceMappingURL=websdk-allavailabilities.service.js.map